import React, { useEffect, useState } from "react";
import { ACTS } from "../content";

/**
 * There is no navbar.
 *
 * Instead the four corners of the viewport carry a heads-up display: identity,
 * live act index, local time, and one control that detonates into a full-screen
 * index. Nothing sits in a bar across the top, and nothing ever scrolls away.
 */
export default function HUD({ act, open, onToggle, onJump }) {
  const [clock, setClock] = useState("");

  useEffect(() => {
    const paint = () =>
      setClock(
        new Date().toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
    paint();
    const id = setInterval(paint, 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape" && open) onToggle(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onToggle]);

  const current = ACTS.findIndex((a) => a.id === act);
  const index = current < 0 ? 0 : current;

  return (
    <>
      <header className="hud" data-open={open || undefined}>
        <a className="hud__mark" href="#top" data-lens="TOP" aria-label="AB App Studio — back to top">
          <span className="hud__mark-ab">AB</span>
          <span className="hud__mark-rest mono">APP&nbsp;STUDIO</span>
        </a>

        <nav className="hud__acts" aria-label="Section index">
          <ol>
            {ACTS.map((a, i) => (
              <li key={a.id} data-on={i === index || undefined}>
                <button className="mono" onClick={() => onJump(a.id)} data-lens="GO">
                  <em>{String(i + 1).padStart(2, "0")}</em>
                  <span>{a.label}</span>
                </button>
              </li>
            ))}
          </ol>
        </nav>

        <div className="hud__meta mono" aria-hidden="true">
          <span>LDN {clock}</span>
          <span className="hud__live">
            <i /> 2 APPS LIVE
          </span>
        </div>

        <button
          className="hud__toggle"
          onClick={() => onToggle(!open)}
          aria-expanded={open}
          aria-label={open ? "Close index" : "Open index"}
          data-lens={open ? "CLOSE" : "INDEX"}
        >
          <span className="mono">{open ? "CLOSE" : "INDEX"}</span>
          <span className="hud__toggle-glyph">
            <i />
            <i />
          </span>
        </button>
      </header>

      <div
        className={`overlay${open ? " is-open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label="Index"
        inert={!open || undefined}
      >
        <ol className="overlay__list">
          {ACTS.map((a, i) => (
            <li key={a.id} style={{ "--i": i }}>
              <button onClick={() => onJump(a.id)} data-lens="GO">
                <span className="mono">{String(i + 1).padStart(2, "0")}</span>
                <span className="overlay__word display">{a.label}</span>
                <span className="mono overlay__note">{a.note}</span>
              </button>
            </li>
          ))}
        </ol>

        <div className="overlay__foot">
          <a className="mono" href="https://getpulled.app" target="_blank" rel="noreferrer" data-lens="OPEN">
            GETPULLED.APP ↗
          </a>
          <a className="mono" href="https://getsaved.app" target="_blank" rel="noreferrer" data-lens="OPEN">
            GETSAVED.APP ↗
          </a>
        </div>
      </div>
    </>
  );
}
